import { SVGProps, Ref, forwardRef } from 'react';

export const FolderHyperstarOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.2 2.333h2.133c3.153 0 4.413.947 4.632 3.692.798.48 1.107 1.32 1.021 2.642H14.58c.066-.82-.06-1.158-.164-1.294-.116-.152-.54-.473-2.21-.473h-8.41c-1.67 0-2.094.32-2.21.473-.145.191-.34.78.02 2.534.349 1.69.77 2.524 1.26 2.978.451.416 1.19.715 2.735.715h4.067V15H5.6C2.204 15 .959 13.707.234 10.19-.22 7.98-.038 6.698 1 6.048v-.381C1 2.167 2.167 1 5.667 1h2zM5.667 2.4c-1.672 0-2.342.297-2.656.61-.31.31-.601.963-.61 2.578q.61-.089 1.395-.088h8.408q.722 0 1.297.074c-.113-.675-.309-1.027-.512-1.23-.314-.314-.984-.61-2.656-.61H7.252L6.719 2.4z"
                        fill="currentColor"
                    />
                    <path
                        d="M13.5 10a9.5 9.5 0 0 0 2.5 2.5 9.5 9.5 0 0 0-2.5 2.5 9.5 9.5 0 0 0-2.5-2.5 9.5 9.5 0 0 0 2.5-2.5"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
FolderHyperstarOutlinedSize16Glyph.displayName = 'FolderHyperstarOutlinedSize16Glyph';
